// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__usrhv","sendOtp":"AuthorizeToLogin_sendOtp__1NnJZ"};